.form {
	width: 50rem;
	padding: 1rem;
}
.tagContainer,
label {
	width: 17rem;
}
label input[type='file'] {
	width: 17rem;
}
.img {
	width: 10rem;
	height: 10rem;
	border-radius: 50%;
	border: 1rem solid rgb(0, 0, 0);
}
.main {
	min-width: 150px;
}

.multiSelect {
	max-width: 17rem;
}
